// EstimateBudgetItemLayer Component
import React from 'react'
import PropTypes from 'prop-types'
import { DragLayer } from 'react-dnd'

import FavouriteItemBase from './favourite_itembase.jsx'

function getItemStyles (props) {
  const { initialOffset, currentOffset } = props
  if (!initialOffset || !currentOffset) {
    return {
      display: 'none'
    }
  }

  const { x, y } = currentOffset
  const transform = `translate(${x - 20}px, ${y - 30}px)`
  return {
    transform: transform,
    WebkitTransform: transform
  }
}

@DragLayer((monitor) => ({
  item: monitor.getItem(),
  itemType: monitor.getItemType(),
  initialOffset: monitor.getInitialSourceClientOffset(),
  currentOffset: monitor.getClientOffset(),
  isDragging: monitor.isDragging()
}))
class FavouriteItemLayer extends FavouriteItemBase {
  static get propTypes () {
    return {
      item: PropTypes.object,
      currentUser: PropTypes.bool,
      showEdit: PropTypes.bool,
      index: PropTypes.number.isRequired,
      initialOffset: PropTypes.shape({
        x: PropTypes.number.isRequired,
        y: PropTypes.number.isRequired
      }),
      currentOffset: PropTypes.shape({
        x: PropTypes.number.isRequired,
        y: PropTypes.number.isRequired
      }),
      isDragging: PropTypes.bool.isRequired
    }
  }

  static get defaultProps () {
    return {
      item: null,
      currentUser: false,
      showEdit: false,
      index: -1,
      isDragging: false,
      connectDragSource: null,
      connectDropTarget: null,
      onClick: null,
      onDelete: null,
      onMoveItem: null,
      onDragEnd: null
    }
  }

  render () {
    const { isDragging } = this.props
    return (
      <div
        className={`timefavouritedraglayer${isDragging ? ' active' : ''}`}
        style={getItemStyles(this.props)}
      >
        {super.render()}
      </div>
    )
  }
}

export default FavouriteItemLayer
